import { hasConsent, initAnalytics, trackPageView } from "./src/utils/analytics";

export const onClientEntry = (): void => {
    if (hasConsent()) {
        initAnalytics();
    }
};

// Fires on the initial load AND every client-side navigation.
// trackPageView is a no-op until initAnalytics has run, so nothing
// loads or fires before consent.
export const onRouteUpdate = (): void => {
    trackPageView();
};
